import React, { Component } from 'react';
import PromotionBenefits from '../utils/PromotionBenefits';
import {RewardBadge,RewardOffers} from '../utils/RewardProduct';
import CheckoutSeller from './CheckoutSeller';
import CartMessages from '../utils/CartMessages';
import OrganicDivider from '../utils/OrganicDivider';
import './CartTheme.css';
import './CheckoutTheme.css';
import { addressApi, cartApi, getBrowserCountryCode, setGuestCartId, shippingApi, storefrontApi } from '../../api/Api';
import { Link } from 'react-router-dom';
import { removecart } from '../../utils/byoscart';
import CheckoutAvailabilityNotice from '../utils/CheckoutAvailabilityNotice';
import {orderApi, newRequestKey, errorMessage} from '../../api/orders';
import {openRazorpay} from '../../utils/razorpayCheckout';
import {clearCheckoutPromo, readCheckoutPromo, saveCheckoutPromo} from '../../utils/checkoutPromo';
import {rewardCartKey} from '../../utils/rewardSelection';

import { message } from 'antd';
import { NotificationContainer, NotificationManager } from 'react-notifications';

class Checkout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cartCountryId: null,
            wishlist: [],
            totalBox: [],
            addressList: [],
            gst_number: '',
            businessName: '', billingSame: true, billingAddressId: '',
            checkoutQuote: null, quoteContext: '', paymentBusy: false, paymentPreparing: false, paymentError: '', paymentOrderNumber: '', paymentNotice:'',
            deliveryaddress: '',
            selectedAddress: {},
            messagesUpdating: false,
            shippingQuote: null,
            shippingLoading: false,
            shippingError: '',
            states: [],
            statesLoaded: false,
            serviceCheck: false,
            promoInput: '',
            promoCode: '',
            promoPricing: null,
            rewardSelections: {}, promotionQuote: null,
            promoContext: '',
            promoLoading: false,
            promoError: '',
            promoMessage: '',
        };
        this.openPayModal = this.openPayModal.bind(this);
    }

    async componentDidMount() {
        this.checkoutUnmounted = false;
        if (this.initialLoadStarted) return;
        this.initialLoadStarted = true;
        try {
            await this.loadAddresses();
            await this.loadCart({ calculate: false, restorePromo:true });
            await this.restoreCheckout();
            await this.calculateShipping({ silent: true });
        } catch (error) {
            console.error(error);
        }


    }

    componentWillUnmount() {
        this.checkoutUnmounted = true;
        this.checkoutWindow?.close?.();
        this.promoRequestVersion = (this.promoRequestVersion || 0) + 1;
        this.shippingVersion = (this.shippingVersion || 0) + 1;
    }

    async restoreCheckout() {
        try {
            const response = await orderApi.current();
            const order = response.data?.data;
            if (this.checkoutUnmounted || !order?.order_number) return;
            const input = order.checkout_input || {};
            const address = this.state.addressList.find(item => Number(this.getAddressId(item)) === Number(input.address_id));
            const fromCart = this.props.location?.state?.rewardCartKey === rewardCartKey(this.state.wishlist, this.state.cartCountryId);
            await this.setStateAsync({
                paymentOrderNumber:order.order_number,
                paymentNotice:order.payment_processing ? 'Your previous payment is being checked. View its status before paying again.' : 'Your unfinished checkout is ready. Review your details, then continue to pay or edit your cart.',
                ...(address ? {deliveryaddress:String(input.address_id), selectedAddress:address} : {}),
                ...(order.checkout_input ? {billingSame:!input.billing_address_id, billingAddressId:input.billing_address_id ? String(input.billing_address_id) : '',
                    gst_number:input.gstin || '', businessName:input.business_name || '',
                    ...(!fromCart ? {promoCode:this.state.promoCode || input.promocode || '', promoInput:this.state.promoCode || input.promocode || '', rewardSelections:input.reward_selections || {}} : {})} : {}),
            });
        } catch {
            // Placement still recovers/revalidates on the server if this read fails.
        }
    }

    getPricingContext() {
        return JSON.stringify([localStorage.getItem('country_id'), this.state.cartCountryId,
            this.state.deliveryaddress, this.state.selectedAddress, this.state.wishlist, this.state.totalBox, this.state.rewardSelections]);
    }

    getPromoPricing() {
        return this.state.promoPricing && this.state.promoContext === this.getPricingContext() ? this.state.promoPricing : null;
    }

    invalidatePricing() {
        this.promoRequestVersion = (this.promoRequestVersion || 0) + 1;
        this.shippingVersion = (this.shippingVersion || 0) + 1;
        this.shippingRequestKey = null;
        this.shippingRequest = null;
        this.setState({promoPricing:null, promoContext:'', promoMessage:'', promoLoading:false, shippingQuote:null});
    }

    async refreshPromotion(code) {
        const version = this.promoRequestVersion = (this.promoRequestVersion || 0) + 1;
        this.shippingVersion = (this.shippingVersion || 0) + 1;
        this.shippingRequestKey = null;
        this.shippingRequest = null;
        const context = this.getPricingContext();
        const identity = () => JSON.stringify([localStorage.getItem('natureway_token'), localStorage.getItem('natureway_guest_cart_id')]);
        const owner = identity();
        const current = () => !this.checkoutUnmounted && version === this.promoRequestVersion && context === this.getPricingContext() && owner === identity();
        this.setState({promoLoading:true, promoError:'', promoMessage:'', shippingLoading:false});
        try {
            if (!this.state.deliveryaddress) throw new Error('Select a delivery address before applying a promo code.');
            const stateId = await this.getAddressStateId(this.state.selectedAddress || {});
            if (!current()) return null;
            if (!stateId) throw new Error('A valid delivery state is required to calculate your promo savings.');
            const items = this.state.wishlist.map(item => ({product_id:Number(item.product_id), product_sku_id:Number(item.product_sku_id), quantity:Number(item.quantity)}));
            if (!items.length || items.some(item => !Number.isInteger(item.product_id) || item.product_id < 1 || !Number.isInteger(item.product_sku_id) || item.product_sku_id < 1 || !Number.isInteger(item.quantity) || item.quantity < 1)) {
                throw new Error('Refresh your cart before applying a promo code.');
            }
            const response = await cartApi.pricing({
                country_id:Number(localStorage.getItem('country_id') || this.state.cartCountryId) || undefined,
                state_id:stateId, items, promocode:code, ...(Object.keys(this.state.rewardSelections || {}).length ? {reward_selections:this.state.rewardSelections} : {}),
            });
            if (!current()) return null;
            const pricing = response.data?.data;
            if (response.data?.status !== 'success' || (code && pricing?.promocode?.applied !== true)) {
                throw new Error(pricing?.promocode?.message || response.data?.message || 'This promo code could not be applied.');
            }
            const amounts = ['mrp_subtotal', 'subtotal', 'automatic_discount', 'promocode_discount', 'shipping_discount', 'shipping_charge', 'total', 'grand_total'];
            if (amounts.some(key => pricing[key] === null || pricing[key] === undefined || !Number.isFinite(Number(pricing[key])) || Number(pricing[key]) < 0) || pricing.shipping?.available !== true || (code && pricing.promocode.code !== code)) {
                throw new Error('We couldn’t confirm the updated total. Please try again.');
            }
            const quote = {...pricing.shipping, shipping_charge:Number(pricing.shipping_charge)};
            if (code) await saveCheckoutPromo(code, current);
            if (!current()) return null;
            await this.setStateAsync({
                promoCode:code, promoInput:code || this.state.promoInput, promoPricing:pricing, promotionQuote:pricing, promoContext:context,
                promoLoading:false, promoError:'', promoMessage:code ? pricing.promocode.message || 'Promo code applied.' : '',
                shippingQuote:quote, shippingLoading:false, shippingError:'',
            });
            return quote;
        } catch (error) {
            if (!current()) return null;
            this.setState({promoPricing:null, promoContext:'', promoLoading:false, promoMessage:'',
                promoError:error.response?.data?.message || error.message || 'Unable to check this code. Please try again.'});
            return null;
        } finally {
            if (!this.checkoutUnmounted && version === this.promoRequestVersion && !current()) {
                this.setState({promoLoading:false, promoPricing:null, promoContext:'', promoMessage:'',
                    promoError:'Your cart or delivery details changed. Please check the code again.'});
            }
        }
    }

    applyPromotion = event => {
        event?.preventDefault();
        if (this.state.promoLoading || this.state.messagesUpdating || this.state.shippingLoading) return;
        const code = this.state.promoInput.trim().toUpperCase();
        if (!code) {
            this.setState({promoError:'Enter a promo code.'});
            return;
        }
        return this.refreshPromotion(code);
    };

    removePromotion = () => {
        clearCheckoutPromo();
        this.invalidatePricing();
        this.setState({promoCode:'', promoInput:'', promoError:'', promoMessage:'Promo code removed.'}, () => this.calculateShipping({force:true}));
    };

    async loadAddresses() {
        if (this.addressRequest) return this.addressRequest;

        this.addressRequest = (async () => {
        try {
            const response = await addressApi.list();
            const resVal = response.data;
            if (resVal.status !== 'success') {
                NotificationManager.error(resVal.message);
                return [];
            }
            const addressList = Array.isArray(resVal.data) ? resVal.data : [];
            const defaultAddress = addressList.find((address) => this.isDefaultAddress(address)) || addressList[0] || {};
            const defaultAddressId = this.getAddressId(defaultAddress);
            await this.setStateAsync({
                addressList,
                deliveryaddress: defaultAddressId ? `${defaultAddressId}` : '',
                selectedAddress: defaultAddress,
            });
            return addressList;
        } catch (error) {
            console.error(error);
            return [];
        } finally {
            this.addressRequest = null;
        }
        })();

        return this.addressRequest;
    }

    isDefaultAddress(address = {}) {
        return address.is_default === true
            || address.is_default === 1
            || address.is_default === '1'
            || address.is_default === 'true';
    }

    setStateAsync(nextState) {
        return new Promise((resolve) => this.setState(nextState, resolve));
    }

    async loadCart({ calculate = true, restorePromo = false } = {}) {
        this.invalidatePricing();
        this.setState({ messagesUpdating: true });
        try {
            // Resolve the numeric country ID from the home page's country-code
            // flow so checkout messages use the active storefront country.
            try {
                await storefrontApi.getHome();
            } catch (error) {
                console.error(error);
            }
            const response = await cartApi.detail({
                country_id: localStorage.getItem('country_id') || undefined,
            });
            const resVal = response.data;
            if (resVal.status === 'success') {
                setGuestCartId(resVal.guest_cart_id);
                const items = Array.isArray(resVal.data) ? resVal.data : [];
                const savedCode = restorePromo && items.length ? await readCheckoutPromo() : null;
                const carriedRewards = this.props.location?.state;
                const restoreRewards = restorePromo && carriedRewards?.rewardCartKey === rewardCartKey(items, resVal.country_id);
                if (this.checkoutUnmounted) return;
                if (!items.length) clearCheckoutPromo();
                await this.setStateAsync({
                    cartCountryId: resVal.country_id,
                    promotionQuote: resVal.promotion_quote || null,
                    wishlist: items,
                    ...(restoreRewards ? {rewardSelections:carriedRewards.rewardSelections || {}} : {}),
                    totalBox: resVal.totalAmount,
                    serviceCheck: true,
                    ...(!items.length ? {promoCode:'', promoInput:'', promoError:'', promoMessage:''}
                        : savedCode ? {promoCode:savedCode, promoInput:savedCode} : {}),
                });
            } else {
                this.setState({ serviceCheck: true });
            }
        } catch (error) {
            this.setState({ serviceCheck: true });
            console.error(error);
        }
        finally {
            this.setState({ messagesUpdating: false });
        }
        if (calculate) {
            await this.calculateShipping({ silent: true });
        }
    }

    async localremovewishlist(cart_id) {
        this.invalidatePricing();
        this.setState({ messagesUpdating: true });
        await removecart(cart_id);
        await this.loadCart();
    }

    async updateCart(typeVal, cart_id, quantity = 0) {
        this.invalidatePricing();
        this.setState({ messagesUpdating: true });
        try {
            const response = await cartApi.updateItem(cart_id, {
                type: typeVal,
                quantity,
                country_id: localStorage.getItem('country_id') || undefined,
            });
            const resVal = response.data;
            if (resVal.status === 'success') {
                setGuestCartId(resVal.guest_cart_id);
                await this.loadCart();
                message.success({
                    content: resVal.message,
                    className: 'notificationBox',
                });
            }
        } catch (error) {
            this.setState({ serviceCheck: true });
            console.error(error);
        }
        finally {
            this.setState({ messagesUpdating: false });
        }
    }

    updateDeliveryAddress(addressId) {
        this.invalidatePricing();
        const selectedAddress = this.state.addressList.find((address) => `${this.getAddressId(address)}` === `${addressId}`) || {};
        this.setState({
            deliveryaddress: `${addressId}`,
            selectedAddress,
            shippingQuote: null,
            shippingError: '',
        }, () => this.calculateShipping());
    }

    getAddressId(address = {}) {
        return address.address_id || address.id || '';
    }

    getAddressField(address = {}, legacyKey, modernKey) {
        return address[legacyKey] || address[modernKey] || '';
    }

    normalizeStateName(value) {
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    extractList(payload, keys = ['data', 'states']) {
        if (Array.isArray(payload)) {
            return payload;
        }

        for (const key of keys) {
            if (Array.isArray(payload && payload[key])) {
                return payload[key];
            }
        }

        if (payload && payload.data && Array.isArray(payload.data.data)) {
            return payload.data.data;
        }

        return [];
    }

    async loadStates() {
        if (this.state.statesLoaded) {
            return this.state.states;
        }

        if (this.statesRequest) {
            return this.statesRequest;
        }

        this.statesRequest = (async () => {
          try {
            const response = await shippingApi.states();
            const states = this.extractList(response.data);
            this.setState({ states, statesLoaded: true });
            return states;
          } catch (error) {
            console.error(error);
            this.setState({ statesLoaded: true });
            return [];
          } finally {
            this.statesRequest = null;
          }
        })();

        return this.statesRequest;
    }

    async getAddressStateId(address) {
        const directStateId = address.state_id || address.shipping_state_id || address.user_state_id;

        if (directStateId) {
            return Number(directStateId);
        }

        const stateName = address.state || address.user_state || '';

        if (!stateName) {
            return null;
        }

        const states = await this.loadStates();
        const normalizedStateName = this.normalizeStateName(stateName);
        const matchedState = states.find((state) => {
            const candidates = [
                state.id,
                state.name,
                state.state,
                state.title,
                state.code,
                state.slug,
            ];

            return candidates.some((candidate) => this.normalizeStateName(candidate) === normalizedStateName);
        });

        return matchedState ? Number(matchedState.id || matchedState.state_id) : null;
    }

    getCartAmountBeforeShipping(totalBox = this.state.totalBox) {
        const pricing = this.getPromoPricing();
        if (pricing && totalBox === this.state.totalBox) return Number(pricing.total);
        return Number(totalBox.total_cart_value ?? totalBox.sub_total_cart_value ?? 0);
    }

    getShippingCharge(quote = this.state.shippingQuote) {
        const pricing = this.getPromoPricing();
        if (pricing && quote === this.state.shippingQuote) return Math.max(Number(pricing.shipping_charge) - Number(pricing.shipping_discount), 0);
        return Number(quote && quote.available !== false ? quote.shipping_charge || 0 : 0);
    }

    getFallbackShippingQuote(message = '') {
        return {
            available: true,
            shipping_charge: Number((this.state.totalBox && this.state.totalBox.total_delivery_charges) || 0),
            message,
            fallback: true,
        };
    }

    getGrandTotal(quote = this.state.shippingQuote) {
        const pricing = this.getPromoPricing();
        if (pricing && quote === this.state.shippingQuote) return Number(pricing.grand_total);
        return this.getCartAmountBeforeShipping() + this.getShippingCharge(quote);
    }

    getShippingItems() {
        return (Array.isArray(this.state.wishlist) ? this.state.wishlist : [])
            .map((item) => ({
                product_sku_id: Number(item.product_sku_id || 0),
                quantity: Number(item.quantity || 1),
            }))
            .filter((item) => item.product_sku_id > 0 && item.quantity > 0);
    }

    buildShippingRequestKey(stateId, items, cartSubtotal) {
        return JSON.stringify({
            stateId,
            cartSubtotal,
            items,
        });
    }

    async calculateShipping(options = {}) {
        const benefits = this.state.promotionQuote;
        if (this.state.promoCode || benefits?.reward_items?.length || benefits?.reward_choices?.length || benefits?.requires_shipping_evaluation) return this.refreshPromotion(this.state.promoCode || '');
        const shippingVersion = this.shippingVersion = (this.shippingVersion || 0) + 1;
        const context = this.getPricingContext();
        const current = () => !this.checkoutUnmounted && shippingVersion === this.shippingVersion && context === this.getPricingContext();
        const cartItems = Array.isArray(this.state.wishlist) ? this.state.wishlist : [];

        if (cartItems.length === 0) {
            this.setState({ shippingQuote: null, shippingError: '', shippingLoading: false });
            return null;
        }

        if (!this.state.deliveryaddress) {
            this.setState({
                shippingQuote: null,
                shippingError: 'Select delivery address to calculate shipping.',
                shippingLoading: false,
            });
            return null;
        }

        const stateId = await this.getAddressStateId(this.state.selectedAddress || {});
        if (!current()) return null;

        if (!stateId) {
            if (this.state.statesLoaded && this.state.states.length === 0) {
                const quote = this.getFallbackShippingQuote('Shipping calculator is not available from the API yet.');
                this.setState({
                    shippingQuote: quote,
                    shippingError: '',
                    shippingLoading: false,
                });
                return quote;
            }

            this.setState({
                shippingQuote: null,
                shippingError: 'Selected address state is not available for shipping calculation.',
                shippingLoading: false,
            });
            return null;
        }

        const items = this.getShippingItems();

        if (items.length !== cartItems.length) {
            this.setState({
                shippingQuote: null,
                shippingError: 'One or more cart items are missing SKU details for shipping.',
                shippingLoading: false,
            });
            return null;
        }

        const cartSubtotal = this.getCartAmountBeforeShipping();
        const requestKey = this.buildShippingRequestKey(stateId, items, cartSubtotal);

        if (!options.force && this.shippingRequestKey === requestKey && this.state.shippingQuote) {
            return this.state.shippingQuote;
        }

        this.shippingRequestKey = requestKey;
        this.setState({ shippingLoading: true, shippingError: '' });

        this.shippingRequest = (async () => {
          try {
            const response = await shippingApi.calculate({
                state_id: stateId,
                cart_subtotal: cartSubtotal,
                items,
            });
            const payload = response.data || {};
            if (!current()) return null;
            const quote = payload.data || payload;
            const messageText = quote && quote.available === false
                ? quote.message || payload.message || 'Delivery is not available for the selected state.'
                : '';

            this.setState({
                shippingQuote: quote,
                shippingLoading: false,
                shippingError: messageText,
            });

            return quote;
          } catch (error) {
            if (!current()) return null;
            console.error(error);
            const isShippingApiUnavailable = error.response && error.response.status === 404;
            const errorMessage = isShippingApiUnavailable
                ? 'Shipping calculator is not available from the API yet.'
                : 'Unable to calculate shipping. Please try again.';
            const fallbackQuote = isShippingApiUnavailable ? this.getFallbackShippingQuote(errorMessage) : null;

            this.setState({
                shippingQuote: fallbackQuote,
                shippingLoading: false,
                shippingError: fallbackQuote ? '' : errorMessage,
            });

            if (!options.silent && !fallbackQuote) {
                NotificationManager.error(errorMessage);
            }

            return fallbackQuote;
          } finally {
            if (current()) this.shippingRequest = null;
          }
        })();

        return this.shippingRequest;
    }

    formatShippingLabel() {
        if (this.state.shippingLoading) {
            return 'Calculating...';
        }

        if (!this.state.shippingQuote || this.state.shippingQuote.available === false) {
            return '--';
        }

        const pricing = this.getPromoPricing();
        const shippingCharge = pricing ? Number(pricing.shipping_charge) : this.getShippingCharge();
        return shippingCharge === 0 ? 'Free' : `₹ ${shippingCharge.toFixed(2)}`;
    }

    canPlaceOrder() {
        return this.state.checkoutAvailability?.checkout_enabled !== false && !this.state.paymentBusy && this.state.deliveryaddress !== ''
            && !this.state.messagesUpdating
            && !this.state.promoLoading
            && (this.getPromoPricing() || this.state.promotionQuote)?.checkout_ready !== false
            && (!this.state.promoCode || Boolean(this.getPromoPricing()))
            && !this.state.shippingLoading
            && this.state.shippingQuote
            && this.state.shippingQuote.available !== false
            && !this.state.shippingError;
    }

    checkoutBody() {
        return {
            address_id: Number(this.state.deliveryaddress),
            ...(!this.state.billingSame ? {billing_address_id:Number(this.state.billingAddressId)} : {}),
            ...(this.state.gst_number.trim() ? {gstin:this.state.gst_number.trim().toUpperCase(), business_name:this.state.businessName.trim()} : {}),
            ...(this.state.promoCode ? {promocode:this.state.promoCode} : {}),
            ...(Object.keys(this.state.rewardSelections || {}).length ? {reward_selections:this.state.rewardSelections} : {}),
            country_id:Number(localStorage.getItem('country_id') || this.state.cartCountryId) || undefined,
        };
    }

    checkoutContext() { return JSON.stringify([this.checkoutBody(), this.state.wishlist]); }

    async startOrderPayment(number) {
        let finished = false;
        let dismissed = false;
        const showResult = notice => {
            if (finished || dismissed) return;
            dismissed = true;
            this.paymentWindowOpen = false;
            if (!this.checkoutUnmounted) {
                this.setState({paymentBusy:false, paymentPreparing:false, paymentNotice:notice});
            }
        };
        try {
            const response = await orderApi.payment(number);
            if (this.checkoutUnmounted) return;
            const options = response.data?.data?.checkout;
            if (!options) {
                throw new Error('Payment details are not ready yet. Please retry payment for this order shortly.');
            }
            this.paymentWindowOpen = true;
            this.checkoutWindow = await openRazorpay(options, async result => {
                // Verification must finish even if the customer navigates away.
                if (finished) return;
                finished = true;
                try {
                    await orderApi.verify(number, result);
                    if (!this.checkoutUnmounted) this.props.history.push(`/orderconfirmation?order=${encodeURIComponent(number)}`);
                } catch (error) {
                    if (!this.checkoutUnmounted) this.props.history.push(`/orderconfirmation?order=${encodeURIComponent(number)}`, {paymentNotice:'Your payment could not be verified yet. Check its status before retrying.'});
                } finally {
                    this.paymentWindowOpen = false;
                    if (!this.checkoutUnmounted) this.setState({paymentBusy:false});
                }
            }, () => showResult('Payment window closed. You can retry payment or edit your checkout. We’ll check its status before another attempt.'), result => {
                if (!finished && !this.checkoutUnmounted) this.setState({paymentNotice:result?.error?.description || 'The payment attempt failed. Try another payment method, or close the payment window to edit checkout.'});
            });
            if (finished || this.checkoutUnmounted) this.checkoutWindow?.close?.();
        } catch (error) {
            this.paymentWindowOpen = false;
            throw error;
        }
    }

    async openPayModal() {
        if (this.paymentWindowOpen || this.paymentInFlight || !this.canPlaceOrder()) return;
        this.paymentInFlight = true;
        this.setState({paymentBusy:true, paymentPreparing:true, paymentError:''});
        try {
            if (!this.state.billingSame && !this.state.billingAddressId) throw new Error('Select your billing address.');
            if (this.state.gst_number.trim() && !this.state.businessName.trim()) throw new Error('Enter the legal business name for GST billing.');
            const shipping = await this.calculateShipping({force:true});
            if (!shipping || shipping.available === false) return;
            const context = this.checkoutContext();
            const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify([localStorage.getItem('natureway_token'), context])));
            const attemptContext = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
            let attempt;
            try {attempt = JSON.parse(sessionStorage.getItem('natureway_checkout_attempt'));} catch {}
            if (attempt && attempt.context !== attemptContext) {
                throw new Error('An earlier order request needs checking. Open My orders before starting a different order.');
            }
            let confirmedQuote = this.state.checkoutQuote;
            if (!attempt && (!confirmedQuote || (this.state.checkoutQuote.expires_at && Date.parse(this.state.checkoutQuote.expires_at) <= Date.now()) || this.state.quoteContext !== context)) {
                const response = await orderApi.quote(this.checkoutBody());
                const quote = response.data?.data;
                if (!quote?.quote_token || !Number.isInteger(quote.grand_total) || quote.grand_total < 100) throw new Error('Unable to confirm your order total.');
                if (this.checkoutUnmounted || context !== this.checkoutContext()) return;
                confirmedQuote = quote;
                this.setState({checkoutQuote:quote, quoteContext:context});
            }
            if (!attempt) {
                attempt = {context:attemptContext, key:newRequestKey(), quote_token:confirmedQuote.quote_token};
                sessionStorage.setItem('natureway_checkout_attempt', JSON.stringify(attempt));
            }
            const placed = await orderApi.place({...this.checkoutBody(), quote_token:attempt.quote_token, idempotency_key:attempt.key});
            const order = placed.data?.data;
            if (!order?.order_number) throw new Error('Order status could not be confirmed. Try again to recover the same order.');
            sessionStorage.removeItem('natureway_checkout_attempt');
            sessionStorage.setItem('natureway_checkout_order', order.order_number);
            this.setState({paymentOrderNumber:order.order_number});
            await this.startOrderPayment(order.order_number);
        } catch (error) {
            if ([409, 422].includes(error.response?.status)) {
                this.setState({checkoutQuote:null, quoteContext:''});
            }
            this.setState({paymentError:errorMessage(error)});
        } finally {
            this.paymentInFlight = false;
            if (!this.checkoutUnmounted) this.setState({paymentPreparing:false});
            if (!this.checkoutUnmounted && !this.paymentWindowOpen) this.setState({paymentBusy:false});
        }
    }

    async recoverPlacement() {
        let attempt;
        try {attempt = JSON.parse(sessionStorage.getItem('natureway_checkout_attempt'));} catch {}
        if (!attempt || this.paymentInFlight || this.paymentWindowOpen) return;
        this.paymentInFlight = true; this.setState({paymentBusy:true, paymentPreparing:true});
        try {
            const response = await orderApi.recover(attempt.key);
            if (response.data?.placement_status === 'created' && response.data.data?.order_number) {
                sessionStorage.removeItem('natureway_checkout_attempt');
                sessionStorage.setItem('natureway_checkout_order', response.data.data.order_number);
                this.setState({paymentOrderNumber:response.data.data.order_number});
                await this.startOrderPayment(response.data.data.order_number);
            } else if (response.data?.placement_status === 'missing' && response.data?.retired === true) {
                sessionStorage.removeItem('natureway_checkout_attempt');
                this.setState({checkoutQuote:null, quoteContext:'', paymentError:'No previous order was created. Review your checkout again.'});
            } else throw new Error('Previous order status is still unknown. Please try recovery again.');
        } catch (error) {this.setState({paymentError:errorMessage(error)});}
        finally {this.paymentInFlight = false;if (!this.checkoutUnmounted) this.setState({paymentPreparing:false});if (!this.checkoutUnmounted && !this.paymentWindowOpen) this.setState({paymentBusy:false});}
    }

    renderPromoCode() {
        const {promoInput, promoCode, promoLoading, promoError, promoMessage, messagesUpdating, shippingLoading} = this.state;
        const pricing = this.getPromoPricing();
        return <div className="nw-checkout-promo" aria-busy={promoLoading}>
            <div className="nw-checkout-promo__heading"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" aria-hidden="true"><path d="M3 3h8l10 10-8 8L3 11Z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg><label htmlFor="checkoutPromoCode">Have a promo code?</label></div>
            <form onSubmit={this.applyPromotion} noValidate>
                <div className="nw-checkout-promo__entry">
                    <input id="checkoutPromoCode" name="promocode" type="text" autoComplete="off" autoCapitalize="characters" spellCheck="false" maxLength={80}
                        placeholder="Enter promo code" value={promoInput} readOnly={Boolean(promoCode)} disabled={promoLoading || messagesUpdating}
                        aria-invalid={Boolean(promoError)} aria-describedby={promoError ? 'checkoutPromoError' : 'checkoutPromoMessage'}
                        onChange={event => this.setState({promoInput:event.target.value, promoError:'', promoMessage:''})}/>
                    {promoCode ? <button type="button" className="nw-checkout-promo__remove" onClick={this.removePromotion} disabled={messagesUpdating}>Remove</button>
                        : <button type="submit" disabled={promoLoading || messagesUpdating || shippingLoading}>{promoLoading ? 'Applying…' : 'Apply'}</button>}
                </div>
            </form>
            {promoCode && <div className={`nw-checkout-promo__applied${!pricing ? ' nw-checkout-promo__applied--pending' : ''}`}><strong>{promoCode}</strong><span>{pricing ? 'Applied to your order' : 'Awaiting validation'}</span></div>}
            {promoError && <p id="checkoutPromoError" className="nw-checkout-promo__error" role="alert">{promoError}{promoCode && ' Retry or remove the code before continuing.'}</p>}
            <p id="checkoutPromoMessage" className="nw-checkout-promo__message" role="status" aria-live="polite">{promoLoading ? 'Checking your code and updating totals…' : promoError ? '' : promoMessage}</p>
            {promoCode && promoError && !promoLoading && <button type="button" className="nw-checkout-promo__retry" onClick={() => this.refreshPromotion(promoCode)} disabled={messagesUpdating}>Check code again</button>}
        </div>;
    }

    getDisplayedItems() {
        const pricing = this.getPromoPricing();
        const paid = this.state.wishlist.map(item => {
            const priced = pricing?.items?.find(line => !line.is_reward && Number(line.product_sku_id) === Number(item.product_sku_id));
            return priced ? {...item, offer_unit_price:priced.offer_unit_price, line_total:priced.line_total, mrp:Number(priced.mrp_subtotal) / Number(priced.quantity)} : item;
        });
        const rewards = (pricing || this.state.promotionQuote)?.reward_items || [];
        return [...paid, ...rewards.map((item,index) => ({...item, cart_id:`reward-${item.reward_promotion_id}-${index}`,
            product_name:item.name, offer_unit_price:Number(item.payable_total ?? item.line_total) / Number(item.quantity),
            mrp:item.unit_price, line_total:item.payable_total ?? item.line_total, is_reward:true}))];
    }

    renderCartMessages() {
        const address = this.state.selectedAddress || {};
        const stateName = this.normalizeStateName(address.state || address.user_state);
        const matchedState = stateName ? this.state.states.find(state =>
            [state.name, state.state, state.title, state.code, state.slug]
                .some(value => this.normalizeStateName(value) === stateName)) : null;
        const stateId = address.state_id || address.shipping_state_id || address.user_state_id
            || (matchedState && (matchedState.id || matchedState.state_id));
        return <CartMessages
            placement="checkout"
            countryCode={getBrowserCountryCode()}
            stateId={stateId}
            items={this.state.messagesUpdating ? [] : this.getPromoPricing()?.items || this.state.promotionQuote?.items || this.state.wishlist}
            subtotal={this.getCartAmountBeforeShipping()}
            refreshKey={JSON.stringify([this.state.deliveryaddress, address,
                localStorage.getItem('natureway_token'), this.state.totalBox])}
        />;
    }

    render() {
        const { totalBox, deliveryaddress, selectedAddress } = this.state;

        if (!this.state.serviceCheck) {
            return (
                <div className="ps-checkout ps-checkout--loading nw-cart nw-checkout" role="status" aria-busy="true" aria-label="Loading checkout">
                    <div className="container whiteContainer ps-checkout-loading" aria-hidden="true">
                        <div className="ps-checkout-loading__crumb" />
                        <div className="nw-checkout__loading-title"><span className="ps-checkout-loading__line ps-checkout-loading__line--title" /><span className="ps-checkout-loading__line" /></div>
                        <div className="ps-checkout-loading__layout">
                            <div className="ps-checkout-loading__main">
                                <div className="ps-checkout-loading__card ps-checkout-loading__card--address">
                                    <span className="ps-checkout-loading__line ps-checkout-loading__line--small" />
                                    <span className="ps-checkout-loading__line ps-checkout-loading__line--title" />
                                    <span className="ps-checkout-loading__field" />
                                    <span className="ps-checkout-loading__line" />
                                    <span className="ps-checkout-loading__line ps-checkout-loading__line--wide" />
                                </div>
                                <div className="ps-checkout-loading__card">
                                    <span className="ps-checkout-loading__line ps-checkout-loading__line--small" />
                                    <span className="ps-checkout-loading__line ps-checkout-loading__line--title" />
                                    <span className="ps-checkout-loading__row" />
                                    <span className="ps-checkout-loading__row" />
                                    <span className="ps-checkout-loading__row" />
                                </div>
                            </div>
                            <div className="ps-checkout-loading__card ps-checkout-loading__summary">
                                <span className="ps-checkout-loading__line ps-checkout-loading__line--small" />
                                <span className="ps-checkout-loading__line ps-checkout-loading__line--title" />
                                <div className="nw-checkout__promo-skeleton"><span className="ps-checkout-loading__line ps-checkout-loading__line--small"/><span className="ps-checkout-loading__field"/></div>
                                <span className="ps-checkout-loading__row" />
                                <span className="ps-checkout-loading__row" />
                                <span className="ps-checkout-loading__button" />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const reviewedQuote = this.state.quoteContext === this.checkoutContext() ? this.state.checkoutQuote : null;
        const grandTotal = reviewedQuote ? reviewedQuote.grand_total / 100 : this.getGrandTotal();
        const canPlaceOrder = this.canPlaceOrder();
        const promoPricing = this.getPromoPricing();
        const summarySubtotal = promoPricing ? Number(promoPricing.mrp_subtotal) : Number(totalBox.sub_total_cart_value || 0);
        const productDiscount = promoPricing ? Math.max(summarySubtotal - Number(promoPricing.subtotal) + Number(promoPricing.automatic_discount), 0) : Number(totalBox.total_discount || 0);

        const selectedAddressType = (selectedAddress.user_address_type === 'W' || selectedAddress.address_type === 'Work') ? 'Work' : 'Home';
        const selectedAddressLine = [
            this.getAddressField(selectedAddress, 'user_address', 'address_line_1'),
            this.getAddressField(selectedAddress, 'user_locality', 'locality'),
            this.getAddressField(selectedAddress, 'user_city', 'city'),
            this.getAddressField(selectedAddress, 'user_state', 'state'),
            this.getAddressField(selectedAddress, 'user_pincode', 'postal_code'),
        ].filter(Boolean).join(', ');

        return (
            <div className="ps-checkout nw-cart nw-checkout">
                <div className="container"><CheckoutAvailabilityNotice onChange={checkoutAvailability => this.setState({checkoutAvailability})} /></div>
                {this.state.paymentNotice && <div className="container"><div className="nw-checkout__resume" role="status">
                    <div><strong>Continue your checkout</strong><p>{this.state.paymentNotice}</p></div>
                    <div><Link to="/cart">Edit cart</Link>{this.state.paymentOrderNumber && <Link to={`/orderconfirmation?order=${encodeURIComponent(this.state.paymentOrderNumber)}`}>View payment status</Link>}</div>
                </div></div>}
                <div className="ps-categogy ps-categogy--separate ps-cart-shell">
                    <div className="container whiteContainer ps-cart-shell__container">
                        <div className="row">
                            <div className="col-12">
                                <nav aria-label="Breadcrumb"><ul className="ps-breadcrumb">
                                    <li className="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                                    <li className="ps-breadcrumb__item"><Link to="/cart">Cart</Link></li>
                                    <li className="ps-breadcrumb__item active" aria-current="page"><span>Checkout</span></li>
                                </ul></nav>
                                {this.state.wishlist.length > 0 && <div className="ps-cart__header">
                                    <div className="ps-cart__headerCopy"><h1>Complete your <span>order</span></h1><OrganicDivider /><p>Confirm your delivery details and review your order.</p></div>
                                    <ol className="nw-cart__steps" aria-label="Checkout progress"><li><Link to="/cart"><span>1</span>Your cart</Link></li><li aria-current="step"><span>2</span>Checkout</li></ol>
                                </div>}
                            </div>

                            <div className="col-12">
                                {this.state.wishlist.length > 0 ? (
                                    <div className="ps-checkout__layout">
                                        <div className="ps-checkout__main">
                                            <section className="ps-checkout-card ps-checkout-card--address">
                                                <div className="ps-checkout-card__header">
                                                    <div>
                                                        <span className="ps-checkout-card__eyebrow">Where it should arrive</span>
                                                        <h2>Delivery address</h2>
                                                    </div>
                                                    <div className="ps-checkout-card__count">{this.state.addressList.length} saved</div>
                                                </div>

                                                <div className="ps-checkout-card__body">
                                                    {this.state.addressList.length > 0 ? (
                                                        <>
                                                            <label className="ps-checkout-card__label" htmlFor="checkoutAddressSelect">
                                                                Delivery address
                                                            </label>
                                                            <select
                                                                id="checkoutAddressSelect"
                                                                className="form-control ps-checkout-card__select"
                                                                value={deliveryaddress}
                                                                onChange={(event) => this.updateDeliveryAddress(event.target.value)}
                                                            >
                                                                <option value="">Select a saved address</option>
                                                                {this.state.addressList.map((data) => (
                                                                    <option key={this.getAddressId(data)} value={this.getAddressId(data)}>
                                                                        {this.getAddressField(data, 'user_name', 'name')} - {this.getAddressField(data, 'user_city', 'city')}, {this.getAddressField(data, 'user_pincode', 'postal_code')}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                            {deliveryaddress ? (
                                                                <div className="ps-checkout-card__preview">
                                                                    <div className="ps-checkout-card__previewHeader">
                                                                        <div>
                                                                            <span className="ps-checkout-card__previewName">{this.getAddressField(selectedAddress, 'user_name', 'name')}</span>
                                                                            <p className="ps-checkout-card__previewMeta">
                                                                                {this.getAddressField(selectedAddress, 'user_mobile', 'mobile')}
                                                                                <span className="ps-checkout-card__badge">{selectedAddressType}</span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <p className="ps-checkout-card__previewAddress">{selectedAddressLine}</p>
                                                                    {this.getAddressField(selectedAddress, 'user_landmark', 'landmark') ? (
                                                                        <p className="ps-checkout-card__previewHint">Landmark: {this.getAddressField(selectedAddress, 'user_landmark', 'landmark')}</p>
                                                                    ) : null}
                                                                </div>
                                                            ) : (
                                                                <div className="ps-checkout-card__empty">
                                                                    Pick an address to view the delivery details here.
                                                                </div>
                                                            )}

                                                            <div className="ps-checkout-card__footer">
                                                                <span className="ps-checkout-card__footerText">Need a different address?</span>
                                                                <Link to="/address" className="ps-checkout-card__link">Add or edit addresses</Link>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="ps-checkout-card__empty">
                                                            No saved address found. Please add one before continuing.
                                                            <div className="ps-checkout-card__footer ps-checkout-card__footer--stacked">
                                                                <Link to="/address" className="ps-checkout-card__link">Add new address</Link>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </section>

                                            <section className="ps-checkout-card ps-checkout-card--table">
                                                <div className="ps-checkout-card__header">
                                                    <div>
                                                        <span className="ps-checkout-card__eyebrow">Your selection</span>
                                                        <h2>Order items</h2>
                                                    </div>
                                                    <Link to="/cart" className="ps-checkout-card__link">Edit cart</Link>
                                                </div>

                                                <div className="nw-checkout-rewards"><PromotionBenefits quote={this.getPromoPricing() || this.state.promotionQuote} busy={this.state.promoLoading} showRewards={false} showChoices={false}/></div>
                                                <div className="ps-checkout-tableWrap">
                                                    <table className="nw-checkout__items-table" aria-label="Order items">
                                                        <colgroup><col className="nw-checkout__col-image" /><col /><col className="nw-checkout__col-price" /><col className="nw-checkout__col-quantity" /><col className="nw-checkout__col-total" /></colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className="ps-product__thumbnail">Product</th>
                                                                <th scope="col" className="ps-product__name">Name</th>
                                                                <th scope="col" className="ps-product__meta">Unit price</th>
                                                                <th scope="col" className="ps-product__meta">Quantity</th>
                                                                <th scope="col" className="ps-product__meta">Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.getDisplayedItems().filter(item=>!item.is_reward).map((product_details) => {
                                                                return (
                                                                    <tr key={product_details.cart_id || product_details.variation_id}>
                                                                        <td className="ps-product__thumbnail">
                                                                            <div className="ps-product__image">
                                                                                {product_details.display_image ?
                                                                                    <figure>
                                                                                        <img src={product_details.display_image} alt={product_details.product_name} loading="lazy" onError={(event) => {
                                                                                            if (!event.currentTarget.src.endsWith('/assets/img/logo-no-image.png')) event.currentTarget.src = '/assets/img/logo-no-image.png';
                                                                                        }} />
                                                                                    </figure>
                                                                                    :
                                                                                    <figure>
                                                                                        <img src='/assets/img/logo-no-image.png' alt="No product" />
                                                                                    </figure>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td className="ps-product__name">
                                                                            {product_details.product_name}
                                                                            {product_details.is_reward && <RewardBadge total={product_details.line_total}/>}
                                                                            {product_details.variant_name && <span className="nw-checkout__variant">{product_details.variant_name}</span>}
                                                                        </td>
                                                                        <td className="ps-product__meta" data-label="Unit price">
                                                                            <div className="nw-checkout__unit-price">
                                                                                <span className="nw-checkout__selling-price">&#8377;{Number(product_details.offer_unit_price ?? product_details.offer_price ?? 0).toFixed(2)}</span>
                                                                                {Number(product_details.mrp || 0) > Number(product_details.offer_unit_price ?? product_details.offer_price ?? 0) ? (
                                                                                    <del className="nw-checkout__mrp">&#8377;{Number(product_details.mrp || 0).toFixed(2)}</del>
                                                                                ) : null}
                                                                            </div>
                                                                        </td>
                                                                        <td className="ps-product__meta" data-label="Quantity">
                                                                            <span>{product_details.quantity}</span>{product_details.is_reward && <small className="nw-reward-quantity">Set by offer</small>}
                                                                        </td>
                                                                        <td className="ps-product__meta" data-label="Total">
                                                                            <span className="nw-checkout__selling-price nw-checkout__line-total">&#8377;{Number(product_details.line_total ?? product_details.total_price ?? 0).toFixed(2)}{product_details.is_reward && Number(product_details.line_total) === 0 && ' · Free'}</span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                            {Boolean((this.getPromoPricing() || this.state.promotionQuote)?.reward_items?.length || (this.getPromoPricing() || this.state.promotionQuote)?.reward_choices?.length) && <tr className="nw-checkout-reward-row"><td colSpan={5}><RewardOffers quote={this.getPromoPricing() || this.state.promotionQuote} busy={this.state.promoLoading} onSelect={(promotionId,rewardId)=>{
                                                                this.invalidatePricing();
                                                                this.setState(previous=>({rewardSelections:{...previous.rewardSelections,[promotionId]:rewardId}}),()=>this.calculateShipping({silent:true}));
                                                            }}/></td></tr>}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </section>
                                        </div>

                                        <aside className="ps-checkout__sidebar">
                                            <div className="ps-checkout-card ps-checkout-card--summary">
                                                <div className="ps-checkout-card__header">
                                                    <div>
                                                        <span className="ps-checkout-card__eyebrow">Ready when you are</span>
                                                        <h2>Order summary</h2>
                                                    </div>
                                                </div>

                                                <div className="ps-checkout-summary">
                                                    {this.renderPromoCode()}
                                                    <div className="ps-checkout-summary__row">
                                                        <span className="ps-checkout-summary__label">Sub Total</span>
                                                        <strong className="ps-checkout-summary__value">&#8377; {summarySubtotal.toFixed(2)}</strong>
                                                    </div>
                                                    {productDiscount > 0 ? (
                                                        <div className="ps-checkout-summary__row">
                                                            <span>Discount</span>
                                                            <strong className="ps-checkout-summary__value">- &#8377; {productDiscount.toFixed(2)}</strong>
                                                        </div>
                                                    ) : null}
                                                    {Number(promoPricing?.promocode_discount) > 0 && <div className="ps-checkout-summary__row nw-checkout-promo__saving"><span>Promo discount</span><strong className="ps-checkout-summary__value">- ₹ {Number(promoPricing.promocode_discount).toFixed(2)}</strong></div>}
                                                    <div className="ps-checkout-summary__row">
                                                        <span className="ps-checkout-summary__label">Delivery Charges</span>
                                                        <strong className="ps-checkout-summary__value">{this.formatShippingLabel()}</strong>
                                                    </div>
                                                    {Number(promoPricing?.shipping_discount) > 0 && <div className="ps-checkout-summary__row nw-checkout-promo__saving"><span>Shipping discount</span><strong className="ps-checkout-summary__value">- ₹ {Number(promoPricing.shipping_discount).toFixed(2)}</strong></div>}
                                                    {this.state.shippingError ? (
                                                        <p className="errorText">{this.state.shippingError}</p>
                                                    ) : null}
                                                    {this.renderCartMessages()}
                                                    <CheckoutSeller countryId={localStorage.getItem('country_id') || this.state.cartCountryId} deliveryCountry={this.state.selectedAddress?.country_code}/>
                                        <div className="ps-checkout-summary__row ps-checkout-summary__row--total">
                                                        <span className="ps-checkout-summary__label">Total</span>
                                                        <strong className="ps-checkout-summary__value ps-checkout-summary__value--total">&#8377; {grandTotal.toFixed(2)}</strong>
                                                    </div>
                                                    <div className="ps-checkout-summary__field">
                                                        <label><input type="checkbox" checked={this.state.billingSame} onChange={event => this.setState({billingSame:event.target.checked})}/> Billing address same as delivery</label>
                                                        {!this.state.billingSame && <><label htmlFor="billingAddress">Billing address</label><select id="billingAddress" className="form-control" value={this.state.billingAddressId} onChange={event => this.setState({billingAddressId:event.target.value})}><option value="">Select address</option>{this.state.addressList.map(address => <option key={this.getAddressId(address)} value={this.getAddressId(address)}>{address.name || address.user_name} — {address.address_line_1 || address.user_address}</option>)}</select><Link to="/address">Add or edit billing address</Link></>}
                                                        <label className="ps-checkout-summary__label" htmlFor="checkoutGstNumber">GST Number <span className="nw-checkout__optional">(optional)</span></label>
                                                        <input
                                                            id="checkoutGstNumber"
                                                            type="text"
                                                            name="gst_number"
                                                            className="form-control gstInputBox"
                                                            value={this.state.gst_number}
                                                            maxLength={15} onChange={(event) => this.setState({ gst_number: event.target.value.toUpperCase() })}
                                                        />
                                                        {this.state.gst_number && <><label htmlFor="businessName">Legal business name</label><input id="businessName" className="form-control" value={this.state.businessName} onChange={event => this.setState({businessName:event.target.value})}/></>}
                                                    </div>
                                                    {this.state.paymentError && <p role="alert">{this.state.paymentError} <Link to="/orders">My orders</Link> <button type="button" disabled={this.state.paymentBusy} onClick={() => this.recoverPlacement()}>Check previous order request</button></p>}
                                                </div>

                                                <div className="ps-checkout-card__actions ps-checkout-card__actions--summary">
                                                    {canPlaceOrder ?
                                                        <button type="button" className="ps-checkout-card__cta" onClick={() => this.openPayModal()}>
                                                            {this.state.paymentOrderNumber ? 'Retry payment' : 'Continue to pay'}
                                                        </button>
                                                        :
                                                        <button type="button" className="ps-checkout-card__cta" disabled>
                                                            {this.state.paymentBusy ? 'Opening payment…' : this.state.shippingLoading ? 'Calculating Shipping' : 'Continue to pay'}
                                                        </button>
                                                    }
                                                    {deliveryaddress === '' ? <p className="errorText">Please select delivery address</p> : null}
                                                    <Link to="/cart" className="nw-checkout__back">Back to cart</Link>
                                                </div>
                                            </div>
                                        </aside>
                                    </div>
                                ) : (
                                    <div className="ps-cart-empty"><div className="ps-cart-empty__content"><h2>Your cart is empty</h2><p>Add your favourites before continuing to checkout.</p><Link to="/" className="ps-cart-empty__button">Start shopping</Link></div></div>
                                )}
                            </div>
                        </div>

                        {this.state.paymentPreparing && <div className="nw-checkout__payment-notice" role="status" aria-live="polite" aria-atomic="true">
                            <span className="nw-checkout__payment-spinner" aria-hidden="true"/>
                            <div><strong>Preparing your payment</strong><p>Please wait. Your secure payment window will open shortly.</p></div>
                        </div>}
                        <NotificationContainer />
                    </div>
                </div>
            </div>
        );
    }
}

export default Checkout;
